const $halfPixelChecker = $('.js__halfpixel-checker')

module.exports = () => {
  const supports = $halfPixelChecker[0].offsetHeight === 1

  $halfPixelChecker.hide()

  return supports
}
